// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__38Z0H","is-dragging":"styles_is-dragging__28TKP"};